import copyIcon from '@/components/icon/copy'

function renderCopyButton(h, trigger, value) {
  if (trigger && (typeof value === 'string' || typeof value === 'number')) {
    return h(
      'div',
      {
        class: 'fjcc facc faic square--18'
      },
      [
        h(
          copyIcon,
          {
            props: {
              value,
              size: 11
            }
          }
        )
      ]
    )
  }
}

function renderValue(h, row) {
  if (row.link) {
    return h(
      'router-link',
      {
        class: 'link',
        props: {
          to: row.to
        }
      },
      [ row.value ]
    )
  }

  return row.value
}

export default function(h) {
  return h(
    'table',
    {
      class: 'entityTable'
    },
    this.rows.map(row => {
      return h(
        'tr',
        {},
        [
          h('td', {}, [ row.title ]),
          h('td', {}, [ renderCopyButton.call(this, h, row.copy, row.value) ]),
          h('td', { class: 'w--100' }, [ renderValue.call(this, h, row) ])
        ]
      )
    })
  )
}
